'use strict';

import React from 'react';
import Post  from './PostComponent'
import $ from 'jquery'

require('styles//Preview.less');

class Preview extends React.Component
{
  constructor(props)
  {
    super(props)
    this.state = {
      data:'',
      cat:''
    }
  }
  componentDidMount()
  {
    var preview = $('#app').data('preview')
    this.setState({
      data:preview
    })
  }
  render()
  {
    return (
      <div className="wp-preview">
        <Post post={this.state.data} cat={this.state.cat} type='preview' />
      </div>
    );
  }
}

Preview.displayName = 'Preview';

Preview.propTypes = {};
Preview.defaultProps = {};

export default Preview;




/** WEBPACK FOOTER **
 ** ./src/components/PreviewComponent.js
 **/